export default "__VITE_ASSET__34b8cbc1__"